import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../utils/api";

// Async Thunk for Category API Call

export const fetchApplianceProducts = createAsyncThunk(
  "appliance_category/fetchApplianceProducts",
  async ({ id, page = 1, perPage = 10, type }, { rejectWithValue }) => {
    try {      
      const response = await API.get(`/appliance-products/${id}?page=${page}&perPage=${perPage}&type=${type}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);
export const fetchApplianceProductInfo = createAsyncThunk(
  "appliance_category/fetchApplianceProductInfo",
  async (id, { rejectWithValue }) => {
    try {      
      const response = await API.get(`/appliance-product/${id}`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

const appProductSlice = createSlice({
    name: "appliance_product",
    initialState: {
        app_products: [],
        app_product_info: {},
        app_loading: false,
        app_error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchApplianceProducts.pending, (state) => {
                state.app_loading = true;
            })
            .addCase(fetchApplianceProducts.fulfilled, (state, action) => {
                state.app_loading = false;
                state.app_products = action.payload;
            })
            .addCase(fetchApplianceProducts.rejected, (state, action) => {
                state.app_loading = false;
                state.app_error = action.payload;
            })
            .addCase(fetchApplianceProductInfo.pending, (state) => {
                state.app_loading = true;
            })
            .addCase(fetchApplianceProductInfo.fulfilled, (state, action) => {
                state.app_loading = false;
                state.app_product_info = action.payload;
            })
            .addCase(fetchApplianceProductInfo.rejected, (state, action) => {
                state.app_loading = false;
                state.app_error = action.payload;
            });
    },
});

export default appProductSlice.reducer;
